"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=tuple-from-union.js.map